import {
  buildInitialEnrollConfig,
  EnrollmentStepData,
} from "../GroupWizard/types";

export interface DynRule {
  operator: string;
  condition_field: string;
  condition: string;
  value: string | null;
}

export interface DynRuleSet {
  operator?: string;
  rules: DynRule[];
}

export interface DynamicGroupWizardData extends EnrollmentStepData {
  name: string;
  description: string;
  sets: DynRuleSet[];
}

export const INITIAL_DYNAMIC_GROUP_DATA: DynamicGroupWizardData = {
  name: "",
  description: "",
  sets: [{ operator: "AND", rules: [] }],
  loSelections: [],
  enrollConfig: buildInitialEnrollConfig(),
};

export const hasValidRuleSets = (sets: DynRuleSet[]): boolean =>
  sets.length > 0 &&
  sets.every(
    (set) =>
      set.rules.length > 0 &&
      set.rules.every((rule) => rule.condition_field && rule.condition),
  );

// BE enums differ by level: rule operator is NOT_AND/NOT_OR, set operator is AND_NOT/OR_NOT.
export const buildRuleOperator = (
  logic: "AND" | "OR",
  exclude: boolean,
): string => `${exclude ? "NOT_" : ""}${logic}`;

// Parses both rule (NOT_AND) and set (AND_NOT) formats.
export const parseRuleOperator = (
  operator: string,
): { logic: "AND" | "OR"; exclude: boolean } => ({
  logic: operator?.replace("NOT_", "").startsWith("OR") ? "OR" : "AND",
  exclude: !!operator?.startsWith("NOT_") || !!operator?.endsWith("_NOT"),
});
